"use strict";

var d3 = require("d3");

var scheme = {
  name: "Original",
  background: "#6A4A3C",
  specials: {
    node_modules: "#FF8553" //eslint-disable-line camelcase
  },
  main: ["#00A0B0", "#CC333F", "#EB6841", "#EDC951"]
};
var lighten = function lighten(n) {
  return function (c) {
    return String(d3.rgb(c).brighter(n));
  };
};
scheme.main = [].concat(scheme.main.map(lighten(0.7))).concat(scheme.main.map(lighten(1.4))).concat(scheme.main.map(lighten(2.0)));
scheme.all = scheme.main.slice();
scheme.modifier = function (a) {
  return a;
};

module.exports = scheme;


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/helpers/modules-helpers/schemes.js
// module id = 631
// module chunks = 0